"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _UIButton = _interopRequireDefault(require("UIComponents/button/UIButton"));

var _UIAdminOnlyWrapper = _interopRequireDefault(require("ui-addon-upgrades/decorators/UIAdminOnlyWrapper"));

var _AdminModalTypes = require("ui-addon-upgrades/_core/common/constants/AdminModalTypes");

function ContactsConfirmationRedirectButton(_ref) {
  var additionalUnitQuantity = _ref.additionalUnitQuantity,
      activeTerm = _ref.activeTerm,
      className = _ref.className,
      merchandiseId = _ref.merchandiseId,
      nonMerchandiseIdIdentifier = _ref.nonMerchandiseIdIdentifier,
      ownsProduct = _ref.ownsProduct,
      onClick = _ref.onClick,
      trackingSource = _ref.trackingSource,
      use = _ref.use,
      children = _ref.children;

  var handleClick = function handleClick() {
    onClick({
      additionalUnitQuantity: additionalUnitQuantity,
      activeTerm: activeTerm,
      merchandiseId: merchandiseId,
      ownsProduct: ownsProduct,
      trackingSource: trackingSource
    });
  };

  return _react.default.createElement(_UIAdminOnlyWrapper.default, {
    adminType: "team",
    modalType: _AdminModalTypes.REQUEST_SKU,
    merchandiseId: merchandiseId
  }, _react.default.createElement(_UIButton.default, {
    "data-selenium-id": trackingSource + "-" + (nonMerchandiseIdIdentifier || merchandiseId) + "-confirm-contacts-button",
    className: className,
    use: use,
    "data-reagan-primary-cta": true,
    onClick: handleClick,
    target: "_blank",
    truncate: true
  }, children || _react.default.createElement(_FormattedMessage.default, {
    message: "pricingPage.pricingCtas." + (ownsProduct ? 'buyAdditionalContacts' : 'buyNow')
  })));
}

ContactsConfirmationRedirectButton.propTypes = {
  additionalUnitQuantity: _propTypes.default.number,
  className: _propTypes.default.string,
  merchandiseId: _propTypes.default.number.isRequired,
  nonMerchandiseIdIdentifier: _propTypes.default.string,
  ownsProduct: _propTypes.default.bool.isRequired,
  onClick: _propTypes.default.func.isRequired,
  trackingSource: _propTypes.default.string.isRequired,
  use: _propTypes.default.string.isRequired,
  activeTerm: _propTypes.default.string.isRequired,
  children: _propTypes.default.node
};
var _default = ContactsConfirmationRedirectButton;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-upgrades/static-9.2952/js/_core/additionalContacts/ContactsConfirmationRedirectButton.js
// module id = 506
// module chunks = 5 6